import styles from './styles.module.scss';

export const Button = ({ type = 'button', children, ...props }) => {
  return (
    <button type={type} {...props} className={styles.button}>
      {children}
    </button>
  );
};
